import { useState, useEffect } from 'react';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import { getInstitution } from '../../../api/admin/institutions';
const useInstitutionFormState = (institutionId) => {
    const dispatch = useAppDispatch();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [approvalStatus, setApprovalStatus] = useState('new');
    const [approvalFile, setApprovalFile] = useState(null);
    const [approvalMessage, setApprovalMessage] = useState('');
    const [sendCredentialsEmail, setSendCredentialsEmail] = useState(false);
    const [emailLanguage, setEmailLanguage] = useState('de');
    const [isStateReady, setIsStateReady] = useState(false);
    const [updatedFormFields, setUpdatedFormFields] = useState(() => new Set());
    useEffect(() => {
        if (institutionId) {
            const fetchInstitutionData = async () => {
                try {
                    const institution = await getInstitution(institutionId);
                    setName(institution.institution.name);
                    setEmail(institution.email);
                    setIsActive(institution.isActive);
                    setApprovalStatus(institution.institution.approvalStatus);
                    setIsStateReady(true);
                }
                catch (error) {
                    dispatch(setIsModalOpen(true));
                    dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
                }
            };
            fetchInstitutionData();
        }
        else {
            setIsStateReady(true);
        }
    }, []);
    return {
        formState: {
            name,
            setName,
            email,
            setEmail,
            password,
            setPassword,
            confirmPassword,
            setConfirmPassword,
            isActive,
            setIsActive,
            approvalStatus,
            setApprovalStatus,
            approvalFile,
            setApprovalFile,
            approvalMessage,
            setApprovalMessage,
            sendCredentialsEmail,
            setSendCredentialsEmail,
            emailLanguage,
            setEmailLanguage,
        },
        updatedFormFields,
        setUpdatedFormFields,
        isStateReady,
    };
};
export default useInstitutionFormState;
